import StyledList from "./StyledList";

export default StyledList;
